export const navigationLinks = [
  { label: "Início", path: "/" },
  { label: "Quem Somos", path: "/quem-somos" },
  { label: "Portfólio", path: "/portfolio" },
  { label: "Contato", path: "/contato" },
];

export const heroContent = {
  eyebrow: "ENGENHARIA E TECNOLOGIA BIM",
  title: "Coordenação e Modelagem BIM",
  subtitle: "Projetos coordenados com rigor técnico e precisão executiva.",
  primaryCta: "Falar com especialista BIM",
  secondaryCta: "Ver portfólio técnico",
};

export const aboutContent = {
  title: "Quem é a BIMtec",
  intro:
    "A BIMtec Tecnologia da Construção é uma empresa técnica especializada em BIM para engenharia e arquitetura, com foco em projetos complexos que exigem coordenação precisa entre disciplinas.",
  paragraphs: [
    "Atuamos na modelagem e coordenação BIM de arquitetura, estrutura e instalações, estruturando modelos paramétricos preparados para documentação, quantitativos e tomada de decisão em obra.",
    "Nossa atuação é guiada por processos claros: definição de escopo BIM, padrões de modelagem, critérios de nível de detalhamento (LOD) e rotinas de revisão, sempre registradas em relatórios técnicos objetivos.",
    "Trabalhamos ao lado de escritórios, construtoras e incorporadoras que precisam reduzir conflitos em campo, mitigar riscos de alteração tardia de projeto e aumentar a previsibilidade de custo e prazo.",
  ],
  highlights: [
    {
      label: "+ m² modelados",
      description:
        "Experiência em edifícios corporativos, residenciais e empreendimentos industriais.",
    },
    {
      label: "Precisão e rastreabilidade",
      description:
        "Modelos orientados a compatibilização, extração confiável de quantitativos e histórico de revisões.",
    },
    {
      label: "Processos BIM estruturados",
      description:
        "Rotinas de coordenação, relatórios de interferência e padronização de entregas para times de projeto e obra.",
    },
  ],
};

export const portfolioProjects = [
  {
    id: "p1",
    name: "Edifício corporativo – Coordenação BIM multidisciplinar",
    segment: "Edificações comerciais",
    location: "Canaã dos Carajás – PA",
    summary:
      "Coordenação BIM de arquitetura, estrutura e instalações, com foco em compatibilização e emissão de relatórios de interferências para apoio à obra.",
    tags: ["Coordenação BIM", "Clash detection", "Relatórios técnicos"],
  },
  {
    id: "p2",
    name: "Empreendimento residencial – Modelagem BIM arquitetônica",
    segment: "Residencial multifamiliar",
    location: "Região Norte",
    summary:
      "Modelagem BIM detalhada de arquitetura para desenvolvimento de pranchas, compatibilização preliminar e estudo de soluções de fachada.",
    tags: ["Modelagem arquitetônica", "Documentação", "Visualização 3D"],
  },
  {
    id: "p3",
    name: "Infraestrutura industrial – As built em BIM",
    segment: "Indústria e mineração",
    location: "Canaã dos Carajás – PA",
    summary:
      "Modelo as built em BIM a partir de documentação existente e levantamentos, estruturando informações para operação e manutenção.",
    tags: ["As built", "Indústria", "Gestão de ativos"],
  },
  {
    id: "p4",
    name: "Implantação de processos BIM em escritório de projetos",
    segment: "Consultoria BIM",
    location: "Brasil",
    summary:
      "Estruturação de fluxos de trabalho, padrões de modelagem, famílias BIM e templates para aumento de eficiência em projetos.",
    tags: ["Implantação BIM", "Padronização", "Treinamentos"],
  },
];

export const contactContent = {
  title: "Contato",
  intro:
    "Conte com a BIMtec Tecnologia da Construção para estruturar seus projetos em BIM com precisão técnica e previsibilidade. Envie uma mensagem ou entre em contato diretamente por e-mail.",
  email: "bimtec.servicos@gmail.com",
};

export const bimHighlights = [
  "Modelagem 3D paramétrica para arquitetura, estrutura e MEP.",
  "Coordenação BIM multidisciplinar com foco em obra.",
  "Detecção e tratamento de interferências (clash detection).",
  "Modelos preparados para extração confiável de quantitativos.",
  "Definição de LOD e escopo BIM alinhados ao empreendimento.",
  "Relatórios técnicos para tomada de decisão em projeto e campo.",
];
